<template>
  <v-row no-gutters>
    <v-col
      class="mb-2 ml-1 text-body-1"
      cols="12"
    >
      {{ label }}
    </v-col>
    <v-col class="mr-1">
      <validation-provider
        v-slot="{ errors }"
      >
        <number-input
          v-model="largeUnit"
          outlined
          dense
          :suffix="largeUnitSuffix"
          :placeholder="$t('label.e_g') + ' ' + 2"
          :decimal-precision="0"
          :error-messages="errors"
        />
      </validation-provider>
    </v-col>
    <v-col class="ml-1">
      <validation-provider
        v-slot="{ errors }"
      >
        <number-input
          v-model="smallUnit"
          outlined
          dense
          :suffix="smallUnitSuffix"
          :placeholder="$t('label.e_g') + ' ' + 500"
          :decimal-precision="0"
          :error-messages="errors"
        />
      </validation-provider>
    </v-col>
  </v-row>
</template>

<script>
import NumberInput from '@/components/helpers/NumberInput.vue'

export default {
  name: 'KilometerMeterInput',
  components: { NumberInput },
  props: {
    value: {
      type: [Number, null],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    variable: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      largeUnit: null,
      smallUnit: null
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    isImperial() {
      return this.user?.organisation_settings?.unit_system === 'imperial'
    },
    largeUnitSuffix() {
      return this.isImperial ? 'mi' : 'km'
    },
    smallUnitSuffix() {
      return this.isImperial ? 'ft' : 'm'
    },
    conversionFactor() {
      return this.isImperial
        ? { large: 1609.344, small: 0.3048 }
        : { large: 1000, small: 1 }
    }
  },
  watch: {
    largeUnit(val) {
      this.emitChange()
    },
    smallUnit(val) {
      this.emitChange()
    }
  },
  created() {
    this.largeUnit = this.calculateLargeUnit()
    this.smallUnit = this.calculateSmallUnit()
  },
  methods: {
    calculateLargeUnit() {
      if (!this.value) return null
      return Math.floor(this.value / this.conversionFactor.large)
    },
    calculateSmallUnit() {
      if (!this.value) return null
      const remaining = this.value % this.conversionFactor.large
      return Math.round(remaining / this.conversionFactor.small)
    },
    emitChange() {
      const totalInMeters = (this.largeUnit || 0) * this.conversionFactor.large +
        (this.smallUnit || 0) * this.conversionFactor.small
      this.$emit('input', totalInMeters)
    }
  }
}

</script>

<style scoped>

</style>
